export const NEW_PATH = 'nouveau'
export const EXAMPLE = 'example'
